import React from 'react';
import { Popover } from '@headlessui/react';
import { getTooltip } from '../../tooltips';

/**
 * TooltipLabel – drop-in replacement for <label> that appends an ⓘ icon
 * whose pop-over shows the narrative tooltip text associated with the
 * provided parameter key.  Usage:
 *   <TooltipLabel htmlFor="question-id" keyName="question_id">Question ID</TooltipLabel>
 *
 * If keyName isn’t supplied we derive it from the htmlFor attribute by
 * replacing dashes with underscores (so htmlFor="question-id" → "question_id").
 */
const TooltipLabel = ({ htmlFor, keyName, className = '', children }) => {
  const alias = keyName || (htmlFor ? htmlFor.replace(/-/g, '_') : undefined);
  const tip = alias ? getTooltip(alias) : '';

  return (
    <label htmlFor={htmlFor} className={className} style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
      {children}
      {tip && (
        <Popover className="pd-pop">
          <Popover.Button className="pd-tooltip" aria-label="Help" style={{ cursor: 'help' }}>ⓘ</Popover.Button>
          <Popover.Panel className="pd-tooltip-panel" style={{ zIndex: 30 }}>{tip}</Popover.Panel>
        </Popover>
      )}
    </label>
  );
};

export default TooltipLabel; 